import Vue from 'vue';
import VueRouter from 'vue-router';
Vue.use(VueRouter);
import App from '@/views/App';
import Login from '@/views/Login';
import NotFound from '@/views/NotFound';

function guardMyroute(to, from, next) {

  if (localStorage.getItem('role') == 2) {
    next(); // go to '/demo-requests';
  } else if (localStorage.getItem('role') == 3) {
    next(); // go to '/media';
  } else if (localStorage.getItem('role') == 4) {
    next(); // go to '/users';
  } else if (localStorage.getItem('role') == 5) {
    next(); // go to '/users';
  } else {
    next();
  }
}

function myPermissionGuard(to, from, next) {
  if (from.path == '/login') {
    guardMyroute(to, from, next);
  } else {
    var keys = [0, 1, 2, 3, 4, 5,6,7,8,9,10,11,13];
    var values = ['', '', 
      ['/demo-leads','/on-boarding'],
      ['/media', '/posts', '/categories', '/posts/new-post',
        '/posts/unpublished', '/faqs', '/faqcategories',
        '/faqs/new-faq', '/comments', '/meta-tag-setting'],
      ['/organizations','/users', '/users/master', '/users/log',
        '/faqs', '/faqcategories', '/faqs/new-faq', '/support', '/media', '/on-boarding', '/notifications', '/notifications/new', 
        'notifications/update-notification/:notification'],
      ['/on-boarding', '/common/development'],
      ['/demo-leads',],
      ['/support','/development-tasks', '/common/development'],
      ['/development-tasks', '/common/development'],
      ['/development-tasks', '/common/development'],
      ['/organizations','/users', '/users/master', '/users/log',
        '/faqs', '/faqcategories', '/faqs/new-faq', '/support', '/media', '/on-boarding', '/notifications', '/notifications/new', 
        'notifications/update-notification/:notification', '/common/development', '/development-tasks'],
      ['development-tasks', '/common/development'],
      ['development-tasks', '/common/development'],
      ['development-tasks', '/common/development'],

    ];

    var index = localStorage.getItem('role');
    if (index == 0 || index == 1 || index == 3 || index== 7 || index == 8 || index == 9 || index== 10 || index== 11 || index == 13 || index == 4)  {
      next();
    } else {
      var paths = values[index];
      var flag ;
      if(index==4){
        var parent = to.matched[1].path;
        flag = paths.includes(parent);
      }else{
        flag = paths.includes(to.path) || paths.includes(to.matched[1].path);
      }
      if (flag) {
        next();
      } else {
        alert('Access denied! You are not allowed to access this page');
        next('/dashboard');
      }
    }
  }


}

const routes = [{
  path: '/login',
  component: Login,
  meta: {
    auth: false,
    title: 'Login | Foxtek Systems',
  }
},
{
  path: '/',
  component: App,
  redirect: '/dashboard',
  meta: {
    //  auth: ['admin', 'moderator', 'author'],
    auth: true,
    title: 'Dashboard',
  },
  children: [
    // ---------- dashboard routes
    {
      // //
      path: '/dashboard',
      component: () => import('@/components/dashboard'),
      name: 'dashboard',
      meta: {
        breadcrumb: 'Dashboard',
        title: 'Dashboard | Foxtek Systems',
      }
    },

    // ---------- categories routes
    {
      //
      path: '/categories',
      component: () => import('@/components/categories/categories'),
      beforeEnter: myPermissionGuard,
      meta: {
        breadcrumb: 'Categories',
        title: 'Post Categories | Foxtek Systems',
        name: 'Categories',
      },
      children: [{
        path: '',
        component: () => import('@/components/categories/category_table'),
      },
      {
        path: ':category/posts',
        component: () => import('@/components/categories/category'),
        meta: {
          // breadcrumb: (routeParams) => `${routeParams.category}`,
          breadcrumb: 'Post',
          title: 'Posts | Foxtek Systems',
        }
      },
      ]
    },

    // ---------- tags routes
    {
      //
      path: '/tags',
      component: () => import('@/components/tags/tags'),
      beforeEnter: myPermissionGuard,
      meta: {
        breadcrumb: 'Tags',
        title: 'Tags | Foxtek Systems'
      },
      children: [{
        path: '',
        component: () => import('@/components/tags/tag_table'),
      },
      {
        path: '/tags/:tag/posts',
        component: () => import('@/components/tags/tag'),
        meta: {
          // breadcrumb: (routeParams) => `${routeParams.tag}`,
          breadcrumb: 'Post',
          title: 'Posts | Foxtek Systems'
        }
      }
      ],
    },

    // ---------- users routes
    {

      path: '/admin-users',
      component: () => import('@/components/users/admin_users'),
      beforeEnter: myPermissionGuard,
      meta: {
        breadcrumb: 'Admin Users',
        title: 'Admin Users | Foxtek Systems',
        name:'Admin Users',
      },
    },
    {
    path: '/progress-report',
    component: () => import('@/components/users/task_progress'),
    beforeEnter: myPermissionGuard,
    meta: {
      breadcrumb: 'Progress Report',
      title: 'Progress Report | Foxtek Systems',
      name:'Progress Report',
    },
  },
    {
      path: '/users',
      component: () => import('@/components/users/users'),
      beforeEnter: myPermissionGuard,
      meta: {
        breadcrumb: 'All Users',
        title: 'All Users | Foxtek Systems',
        name: 'Users',
      },
      children: [{
        path: '',
        component: () => import('@/components/users/all_users'),
      },
      {
        path: 'banned',
        component: () => import('@/components/users/banned_users'),
        meta: {
          breadcrumb: 'Banned',
          title: 'Banned Users | Foxtek Systems'
        }
      },
      {
        path: 'log',
        component: () => import('@/components/users/log'),
        meta: {
          breadcrumb: 'Log',
          title: 'User Logs | Foxtek Systems'
        },

      }, {
        path: 'admin-log',
        component: () => import('@/components/users/admin_log_index'),
        meta: {
          breadcrumb: 'Admin Log',
          title: 'Admin Logs | Foxtek Systems',
          name: 'Logs'
        },

      },

      //{
      //   path: 'demo-requests',
      //   component: () => import('@/components/users/demo_requests'),
      //   meta: {
      //     breadcrumb: 'Demo Requests'
      //   }
      // },
      // {
      //   path: ':detail/:company/:id',
      //   component: () => import('@/components/users/demo_detail'),
      //   meta: {
      //     breadcrumb: 'Demo Requests'
      //     // breadcrumb: (routeParams) => `${routeParams.company}`
      //   }
      // },
      // {
      //   path: 'demo-requests-schedule',
      //   component: () => import('@/components/users/next_schedule'),
      //   meta: {
      //     breadcrumb: 'Next Schedule'
      //   }
      // },
      {
        path: 'master',
        component: () => import('@/components/users/master_users'),
        meta: {
          breadcrumb: 'Master Users',
          title: 'Master Users | Foxtek Systems'
        },
        children: [{
          path: 'add',
          component: () => import('@/components/users/master_users'),
          meta: {
            breadcrumb: 'Add New',
            title: 'Add Master User | Foxtek Systems'
          }
        },]
      }
      ],
    },
    // ---------- Demo-requests routes
    {
      path: '/demo-leads',
      component: () => import('@/components/users/demos'),
      name: 'Leads',
      meta: {
        breadcrumb: 'Leads',
        title: 'Leads | Foxtek Systems',
        name: 'Leads',
      },
      children: [{
        path: '',
        name: 'lead',
        component: () => import('@/components/users/demo_requests'),
        beforeEnter: myPermissionGuard,
      },
      {
        path: ':detail/:id',
        component: () => import('@/components/customer-view/customerView'),
        meta: {
          breadcrumb: `Lead Details`,
          title: 'Lead Details | Foxtek Systems',
          name: 'Leads',
        }
      },
      {
        path: 'demo-leads-schedule',
        component: () => import('@/components/users/next_schedule'),
        beforeEnter: myPermissionGuard,
        meta: {
          breadcrumb: 'Next Schedule',
          title: 'Leads Schedule | Foxtek Systems',  
          name: 'Leads',
        }
      },
      ],
    },
    //On Boarding Routes
    {
      path: '/on-boarding',
      component: () => import('@/components/users/on_boarding'),
      name: 'on boarding',
      meta: {
        breadcrumb: 'OnBoarding',
        title: 'OnBoarding | Foxtek Systems',
        name: 'Onboarding',
      },
      children: [{
        path: '',
        name: 'lead',
        component: () => import('@/components/users/demo_requests'),
        beforeEnter: myPermissionGuard,
      },
      {
        path: ':detail/:company/:id',
        component: () => import('@/components/users/demo_detail_bkp.vue'),
        meta: {
          title: 'Demo-Request Details | Foxtek Systems',
          name: 'Leads',
          // breadcrumb: 'Demo Requests'
          // breadcrumb: (routeParams) => `${routeParams.company}`
        }
      },
      {
        path: 'demo-leads-schedule',
        component: () => import('@/components/users/next_schedule'),
        beforeEnter: myPermissionGuard,
        meta: {
          breadcrumb: 'Next Schedule',
          title: 'OnBoarding Schedule | Foxtek Systems',
          name: 'Leads',
        }
      },
      ],
    },

    //TasksRoutes
    {
      path: '/tasks',
      component: () => import('@/components/users/tasks'),
      name: 'tasks',
      meta: {
        breadcrumb: 'Tasks',
        title: 'Tasks | Foxtek Systems',
        name: 'Tasks',
      },
    },

    // ---------- organizations routes
    {
      //
      path: '/organizations',
      component: () => import('@/components/organizations/index.vue'),
      beforeEnter: myPermissionGuard,
      meta: {
        breadcrumb: 'All Organizations',
        title: 'Organizations | Foxtek Systems',
        name: 'Organizations',
      },
      children: [
        //{
        //path: '',
       // component: () => import('@/components/organizations/all_organizations'),
      //},
        {
          path: 'all-organizations',
          component: () => import('@/components/organizations/organizations'),
          meta: {
            breadcrumb: 'All Organizations',
            title: 'All Organizations | Foxtek Systems',
            name: 'All Organizations'
          }
        },
      {
        path: 'document/:user_name/:organization_id',
        component: () => import('@/components/organizations/organization_document'),
        meta: {
          // breadcrumb: (routeParams) => `${routeParams.user_name}`,
          breadcrumb: 'Organization Document',
          title: 'Organization Document | Foxtek Systems',
          name: 'Organizations',
        }
      },

        {
          path: 'detail/:user_name/:user/:organization_id',
          component: () => import('@/components/organizations/organization-view/customerView'),
          meta: {
            breadcrumb: 'Organization Detail',
          }
        }
      // {
      //   path: 'settings/:user_name/:organization_id',
      //   component: () => import('@/components/organizations/organization_settings'),
      //   meta: {
      //     breadcrumb: (routeParams) => `${routeParams.user_name}`
      //   }
      // }
      ],
    },

    // ---------- notifications routes
    {
      //
      path: '/notifications',
      component: () => import('@/components/notifications/notifications'),
      beforeEnter: myPermissionGuard,
      meta: {
        breadcrumb: 'All Notifications',
        title: 'Notifications | Foxtek Systems',
        name: 'Notifications',
      },
      children: [{
        path: '',
        component: () => import('@/components/notifications/all_notifications'),
      },
      {
        path: 'new',
        component: () => import('@/components/notifications/new'),
        meta: {
          breadcrumb: 'Send New',
          title: 'New Notification | Foxtek Systems',
          name: 'Notifications',
        }
      },
      {
        path: 'update-notification/:notification',
        component: () => import('@/components/notifications/new'),
        meta: {
          breadcrumb: 'Update Notification',
          title: 'Notification Update | Foxtek Systems',
          name: 'Notifications',
        }
      }
      ],
    },

    // ---------- posts routes
    {
      //
      path: '/posts',
      component: () => import('@/components/posts/posts'),
      beforeEnter: myPermissionGuard,
      meta: {
        breadcrumb: 'All Posts',
        title: 'Posts | Foxtek Systems',
        name: 'Posts',
      },
      children: [{
        path: '',
        component: () => import('@/components/posts/all_posts'),
      },
      {
        path: 'unpublished',
        component: () => import('@/components/posts/unpublished_posts'),
        meta: {
          breadcrumb: 'Unpublished Posts',
          title: 'Unpublished Posts | Foxtek Systems',
          name: 'Posts',
        }
      },
      {
        path: 'new-post',
        component: () => import('@/components/posts/form'),
        meta: {
          breadcrumb: 'New Post',
          title: 'New Post | Foxtek Systems',
          name: 'Posts',
        }
      },
      {
        path: 'update-post/:post',
        component: () => import('@/components/posts/form'),
        meta: {
          // breadcrumb: (routeParams) => `${routeParams.post}`,
          breadcrumb:'Update Posts',
          title: 'Update Post | Foxtek Systems',
          name: 'Posts',
        }
      },
      {
        path: ':post',
        component: () => import('@/components/posts/post'),
        meta: {
          // breadcrumb: (routeParams) => `${routeParams.post}`,
          breadcrumb:'Post',
          title: 'Post | Foxtek Systems',
          name: 'Posts',
        }
      }
      ]
    },

    // ---------- FAQ routes
    {
      //
      path: '/faqs',
      component: () => import('@/components/faqs/faqs'),
      beforeEnter: myPermissionGuard,
      meta: {
        breadcrumb: 'All FAQs',
        title: 'FAQs | Foxtek Systems',
        name: 'FAQ',
      },
      children: [{
        path: '',
        component: () => import('@/components/faqs/all_faqs'),
      },

      {
        path: 'new-faq',
        component: () => import('@/components/faqs/form'),
        meta: {
          breadcrumb: 'New FAQ',
          title: 'New FAQ | Foxtek Systems',
          name: 'FAQs',
        }
      },
      {
        path: 'update-faq/:FAQ',
        component: () => import('@/components/faqs/form'),
        meta: {
          // breadcrumb: (routeParams) => `${routeParams.FAQ}`,
          breadcrumb:'Update FAQ',
          title: 'Update FAQ | Foxtek Systems',
          name: 'FAQs',
        }
      },
      {
        path: ':FAQ',
        component: () => import('@/components/faqs/faq'),
        meta: {
          // breadcrumb: (routeParams) => `${routeParams.FAQ}`,
          breadcrumb:'FAQ',
          title: 'FAQ | Foxtek Systems',
          name: 'FAQs',
        }
      }
      ]
    },
    // ----------FAQ categories routes
    {
      //
      path: '/faqcategories',
      component: () => import('@/components/faqcategories/categories'),
      beforeEnter: myPermissionGuard,
      meta: {
        breadcrumb: 'FAQs Categories',
        title: 'FAQ Categories | Foxtek Systems',
        name: 'FAQ',
      },
      children: [{
        path: '',
        component: () => import('@/components/faqcategories/category_table'),
      },
      {
        path: ':category/posts',
        component: () => import('@/components/faqcategories/category'),
        meta: {
          // breadcrumb: (routeParams) => `${routeParams.FAQcategory}`,
          breadcrumb:'FAQ Category Posts',
          title: 'FAQ Category Posts | Foxtek Systems',
          name: 'FAQ',
        }
      },
      ]
    },
    // ---------- set meta tag page routes
    {
      path: '/meta-tag-setting',
      component: () => import('@/components/metaTag/form'),
      beforeEnter: myPermissionGuard,
      meta: {
        breadcrumb: 'Meta Tag Settings',
        title:'Meta Tag Settings | Foxtek Systems',
        name: 'Meta Tag Settings',
      }
    },
    // ---------- comments routes
    {
      //
      path: '/comments',
      component: () => import('@/components/comments/comments'),
      beforeEnter: myPermissionGuard,
      meta: {
        breadcrumb: 'Comments',
        title: 'Comments | Foxtek Systems',
        name: 'Latest Comments',
      }
    },
    // ---------- Media routes
    {
      //
      path: '/media',
      component: () => import('@/components/media/all_media'),
      beforeEnter: myPermissionGuard,
      meta: {
        breadcrumb: 'Media Upload',
        title: 'Media | Foxtek Systems',
        name: 'Media',
      },
      children: [{
        path: '',
        component: () => import('@/components/media/images'),
      },]
    },
    //----------------case study
     {
      //
      path: '/case-study',
      component: () => import('@/components/case-study/case_study'),
      beforeEnter: myPermissionGuard,
      meta: {
        breadcrumb: 'Case Study',
        title: 'Case Study | Foxtek Systems',
        name: 'Case Study',
      },
      children: [{
        path: '',
        component: () => import('@/components/case-study/all_case_study'),
      },
      {
        path: 'create',
        component: () => import('@/components/case-study/form'),
      },
      {
        path: ':slug',
        component: () => import('@/components/case-study/view'),
      },
        {
          path: 'edit/:slug',
          component: () => import('@/components/case-study/form'),
        },
    ]
    },
    //----------------user guide
    {
      //
      path: '/user-guide',
      component: () => import('@/components/user-guide/index'),
      beforeEnter: myPermissionGuard,
      meta: {
        breadcrumb: 'User Guide',
        title: 'User Guide | Foxtek Systems',
        name: 'User Guide',
      },
      children: [{
        path: '',
        component: () => import('@/components/user-guide/all'),
      },
      {
        path: 'create',
        component: () => import('@/components/user-guide/form'),
      },
      {
        path: ':slug',
        component: () => import('@/components/user-guide/view'),
      },
        {
          path: 'edit/:slug',
          component: () => import('@/components/user-guide/form'),
        },
    ]
    },
    //----------------event
    {
      //
      path: '/event',
      component: () => import('@/components/event/index'),
      beforeEnter: myPermissionGuard,
      meta: {
        breadcrumb: 'Event',
        title: 'Event | Foxtek Systems',
        name: 'Event',
      },
      children: [{
        path: '',
        component: () => import('@/components/event/all'),
      },
      {
        path: 'create',
        component: () => import('@/components/event/form'),
      },
      {
        path: ':slug',
        component: () => import('@/components/event/view'),
      },
        {
          path: 'edit/:slug',
          component: () => import('@/components/event/form'),
        },
    ]
    },
     //----------------brochure
     {
      //
      path: '/brochure',
      component: () => import('@/components/brochure/index'),
      beforeEnter: myPermissionGuard,
      meta: {
        breadcrumb: 'Brochure',
        title: 'Brochure | Foxtek Systems',
        name: 'Brochure',
      },
      children: [{
        path: '',
        component: () => import('@/components/brochure/all'),
      },
      {
        path: 'create',
        component: () => import('@/components/brochure/form'),
      },
      {
        path: ':slug',
        component: () => import('@/components/brochure/view'),
      },
        {
          path: 'edit/:slug',
          component: () => import('@/components/brochure/form'),
        },
    ]
    },
     //----------------webinar
     {
      //
      path: '/webinar',
      component: () => import('@/components/webinar/index'),
      beforeEnter: myPermissionGuard,
      meta: {
        breadcrumb: 'Webinar',
        title: 'Webinar | Foxtek Systems',
        name: 'Webinar',
      },
      children: [{
        path: '',
        component: () => import('@/components/webinar/all'),
      },
      {
        path: 'create',
        component: () => import('@/components/webinar/form'),
      },
      {
        path: ':slug',
        component: () => import('@/components/webinar/view'),
      },
        {
          path: 'edit/:slug',
          component: () => import('@/components/webinar/form'),
        },
    ]
    },
    /// end webinar
    // ---------- settings routes
    {
      //
      path: '/settings',
      component: () => import('@/components/settings/all_settings'),
      beforeEnter: myPermissionGuard,
      meta: {
        breadcrumb: 'General Settings',
        title: 'Settings | Foxtek Systems',
        name: 'Settings',
      },
      children: [{
        path: '',
        component: () => import('@/components/settings/settings'),
      },]
    },
    {
      //
      path: '/calendly-widget-settings',
      component: () => import('@/components/calendly-settings/all_settings'),
      beforeEnter: myPermissionGuard,
      meta: {
        breadcrumb: 'General Settings',
        title: 'Settings | Foxtek Systems',
        name: 'Settings',
      },
      children: [{
        path: '',
        component: () => import('@/components/calendly-settings/settings'),
      },]
    },
    // ---------- support ticket routes
    {
      //
      path: '/support',
      component: () => import('@/components/support/tickets'),
      beforeEnter: myPermissionGuard,
      meta: {
        breadcrumb: 'All Tickets',
        title: 'Support Tickets | Foxtek Systems',
        name: 'Support',
      },
      children: [{
        path: '',
        component: () => import('@/components/support/all_tickets'),
      },
      {
        path: 'ticket/:ticket/:org_id',
        component: () => import('@/components/support/form'),
        meta: {
          title: 'View Support Ticket | Foxtek Systems'
        },
      },
      // {
      //   path: 'ticket_filter',
      //   component: () => import('@/components/support/ticket_filters'),
        
      // },
      {
        path: 'generate',
        component: () => import('@/components/support/add_ticket'),
        meta: {
          breadcrumb: 'New Ticket',
          title: 'New Support Ticket | Foxtek Systems'
        }
      },
      ],
    },
    {
      //
      path: '/quick-task',
      component: () => import('@/components/QuickTask/quickTask'),
      beforeEnter: myPermissionGuard,
      meta: {
        breadcrumb: 'My Task',
        title: 'Quick Task | Foxtek Systems',
        name: 'Quick Task',
      },
      children: [
        {
          path: 'my-task',
          component: () => import('@/components/QuickTask/index'),
          meta: {
            taskType: 'myTask',
            breadcrumb: 'My Task',
            title: 'My Task | Foxtek Systems',
            name: 'My Task'
          }
        },
        {
          path: 'assigned-task',
          component: () => import('@/components/QuickTask/index'),
          meta: {
            taskType: 'assignedTask', // Add metadata for assigned tasks
            breadcrumb: 'Assigned Task',
            title: 'Assigned Task | Foxtek Systems',
            name: 'Assigned Task'
          }
        }
      ]
    },

      // Quick Task Routes

    // ---------- Support Requests Routes
    {
      //
      path: '/support-requests',
      component: () => import('@/components/support-requests/requests'),
      beforeEnter: myPermissionGuard,
      meta: {
        breadcrumb: 'Support Requests',
        title:'Support Request | Foxtek Systems',
      },
      children: [{
        path: '',
        component: () => import('@/components/support-requests/all_requests'),
      },
      {
        path: 'request/:request/:org_id',
        component: () => import('@/components/support-requests/form'),
        title:'View Support Request | Foxtek Systems',
      },
      {
        path: 'create',
        component: () => import('@/components/support-requests/add_request'),
        meta: {
          breadcrumb: 'New Request',
          title:'New Support Request | Foxtek Systems',
        }
      },
      ],
    },
    // ---------- term&conditionsroutes
    {
      //
      path: '/term&conditions',
      component: () => import('@/components/terms&conditions/all_terms_&_conditions'),
      beforeEnter: myPermissionGuard,
      meta: {
        breadcrumb: 'Terms & Conditions',
        title: 'Terms & Conditions | Foxtek Systems',
        name: 'Terms & Conditions',
      },
      children: [{
        path: '',
        component: () => import('@/components/terms&conditions/terms_&_conditions'),
      },
      {
        path: 'new-terms',
        component: () => import('@/components/terms&conditions/form'),
        meta: {
          breadcrumb: 'New Terms',
          title: 'New Term & Condition | Foxtek Systems'
        }
      },
      {
        path: ':term',
        component: () => import('@/components/terms&conditions/term_&_condition'),
        meta: {
          breadcrumb: 'Terms And Conditions',
          title: 'Terms & Conditions | Foxtek Systems',
          name: 'Terms And Conditions',
        }
      }
      ]
    },
    {
      path: '/customer-contracts',
      component: () => import('@/components/customer-contracts/contracts'),
      beforeEnter: myPermissionGuard,
      meta: {
        breadcrumb: 'Contract',
        title: 'Contract | Foxtek Systems',
        name: 'Contract',
      },
      children: [{
        path: '',
        component: () => import('@/components/customer-contracts/list'),
      },
      {
        path: 'new-contract',
        component: () => import('@/components/customer-contracts/form'),
        meta: {
          breadcrumb: 'New Contract',
          title: 'New Contract | Foxtek Systems'
        }
      },

      {
        path: 'update-contract/:contract',
        component: () => import('@/components/customer-contracts/form'),
        meta: {
          breadcrumb: 'Update Contract',
          title: 'Contract Update | Foxtek Systems',
        }
      }
      ]
    },
    {
      path: '/development-tasks',
      component: () => import('@/components/tasks/index'),
      beforeEnter: myPermissionGuard,
      meta: {
        breadcrumb: 'Task',
        title: 'Task | Foxtek Systems',
        name: 'Development',
      },
      children: [{
        path: '',
        component: () => import('@/components/tasks/list'),
      },
      // {
      //   path: 'production-tasks',
      //   component: () => import('@/components/development/production_tasks/list'),
      //   meta: {
      //     breadcrumb: 'Production Tasks',
      //     title: 'Production Tasks | Foxtek Systems'
      //   }
      // },

      {
        path: 'schedular',
        component: () => import('@/components/tasks/schedular'),
        meta: {
          breadcrumb: 'Task Schedular',
          title: 'Task Schedular | Foxtek Systems',
        }
      }
      ]
    },
    {
      path: 'common/designer',
      component: () => import('@/components/common/designer/task/index'),
      beforeEnter: myPermissionGuard,
      meta: {
        breadcrumb: 'All Tasks',
        title: 'All Tasks| Foxtek Systems',
        name: 'Designer',
      },
      children: [
        {
          path: 'task',
          component: () => import('@/components/common/designer/task/list'),
        },
        {
          path: 'task/:task_type',
          component: () => import('@/components/common/designer/task/list'),
          meta: {
            breadcrumb: 'Production Tasks',
            title: 'Production Tasks | Foxtek` Systems'
          }
        },
        // {
        //   path: 'task/customer-requirements',
        //   component: () => import('@/components/common/development/task/list'),
        //   meta: {
        //     breadcrumb: 'Customer Requirements Tasks',
        //     title: 'Customer Requirements | Foxtek Systems',
        //   }
        // },
        // {
        //   path: 'task/innovation',
        //   component: () => import('@/components/common/development/task/list'),
        //   meta: {
        //     breadcrumb: 'Innovation Tasks',
        //     title: 'Innovation | Foxtek Systems',
        //   }
        // },
        // {
        //   path: 'task/internal-improvements',
        //   component: () => import('@/components/common/development/task/list'),
        //   meta: {
        //     breadcrumb: 'Internal Improvements Tasks',
        //     title: 'Internal Improvements | Foxtek Systems',
        //   }
        // },
      ]
    },
    {
      path: '/designer-tasks',
      component: () => import('@/components/tasks/index'),
      beforeEnter: myPermissionGuard,
      meta: {
        breadcrumb: 'Task',
        title: 'Task | Foxtek Systems',
        name: 'Designer',
      },
      children: [{
        path: '',
        component: () => import('@/components/tasks/list'),
      },
      // {
      //   path: 'production-tasks',
      //   component: () => import('@/components/development/production_tasks/list'),
      //   meta: {
      //     breadcrumb: 'Production Tasks',
      //     title: 'Production Tasks | Foxtek Systems'
      //   }
      // },

      {
        path: 'designerschedular',
        component: () => import('@/components/tasks/designerschedular'),
        meta: {
          breadcrumb: 'Task Designerschedular',
          title: 'Task Designerschedular | Foxtek Systems',
        }
      }
      ]
    },
    {
      path: 'common/development',
      component: () => import('@/components/common/development/task/index'),
      beforeEnter: myPermissionGuard,
      meta: {
        breadcrumb: 'All Tasks',
        title: 'All Tasks | Foxtek Systems',
        name: 'Development',
      },
      children: [
        {
          path: 'task',
          component: () => import('@/components/common/development/task/list'),
        },
        {
          path: 'task/:task_type',
          component: () => import('@/components/common/development/task/list'),
          meta: {
            breadcrumb: 'Production Tickets',
            title: 'Production Tickets | Foxtek` Systems'
          }
        },
        // {
        //   path: 'task/customer-requirements',
        //   component: () => import('@/components/common/development/task/list'),
        //   meta: {
        //     breadcrumb: 'Customer Requirements Tasks',
        //     title: 'Customer Requirements | Foxtek Systems',
        //   }
        // },
        // {
        //   path: 'task/innovation',
        //   component: () => import('@/components/common/development/task/list'),
        //   meta: {
        //     breadcrumb: 'Innovation Tasks',
        //     title: 'Innovation | Foxtek Systems',
        //   }
        // },
        // {
        //   path: 'task/internal-improvements',
        //   component: () => import('@/components/common/development/task/list'),
        //   meta: {
        //     breadcrumb: 'Internal Improvements Tasks',
        //     title: 'Internal Improvements | Foxtek Systems',
        //   }
        // },
      ]
    },
    {
      path: '/customer-view',
      component: () => import('@/components/customer-view/customerView'),
      beforeEnter: myPermissionGuard,
      meta: {
        breadcrumb: 'Customer',
        title: 'All Tasks | Foxtek Systems',
        name: '',
      },
    }
  ]
},

{
  path: "/404",
  alias: "*",
  component: NotFound
}
];

const router = new VueRouter({
  mode: 'history',
  // base: 'admin-panel',
  base: '',
  linkActiveClass: 'active',
  routes,
});



import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
Vue.use(Loading);
let loader;
const DEFAULT_TITLE = 'Admin-Panel | Foxtek Systems';
router.beforeEach((to, from, next) => {
  if (from.path != '/' && to.path != '/demo-requests' && to.path != '/users' && to.path != 'users/log' && to.path != '/notifications') {
    // loader = Vue.$loading.show({
    // loader: 'dots'
    // });
  }
  
  Vue.nextTick(() => {
    var vue_title;
    if((typeof to.matched[2] === 'undefined'|| to.matched[2].meta['title'] == null) && typeof to.matched[1] !== 'undefined'){
      document.title = to.matched[1].meta['title'] || DEFAULT_TITLE;
    }else if(typeof to.matched[1] === 'undefined'){
      document.title = to.matched[0].meta['title'] || DEFAULT_TITLE;
    }else {
      document.title = to.matched[2].meta['title'] || DEFAULT_TITLE;
    }
    // to.matched[2].meta['title'] ?   :  
  });
  next();

});

router.afterEach((to, from) => {
  // if (from.path != '/') {
  //   setTimeout(() => loader.hide(), 1 * 500)
  // }
  
});


export default router;